import { render, staticRenderFns } from "./ball.vue?vue&type=template&id=fa1f3ea2&"
import script from "./ball.vue?vue&type=script&lang=js&"
export * from "./ball.vue?vue&type=script&lang=js&"
import style0 from "./ball.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa1f3ea2')) {
      api.createRecord('fa1f3ea2', component.options)
    } else {
      api.reload('fa1f3ea2', component.options)
    }
    module.hot.accept("./ball.vue?vue&type=template&id=fa1f3ea2&", function () {
      api.rerender('fa1f3ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ball/ball.vue"
export default component.exports